"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EstateAnalysisRequestSchema = exports.EstateRentRequestSchema = exports.EstateValuationRequestSchema = exports.EstateLookupRequestSchema = exports.EstateRubyAddressSchema = exports.ESTATE_RUBY_ACTIONS = void 0;
const zod_1 = require("zod");
const estate_1 = require("./estate");
/** Route segment → Ruby AI action id (spec 2026-10-11 §8). */
exports.ESTATE_RUBY_ACTIONS = {
    lookup: 'data.property_lookup',
    valuation: 'data.property_valuation',
    rent: 'data.rent_estimate',
    analysis: 'text.property_analysis',
    insights: 'data.area_insights',
};
const s = (max) => zod_1.z.string().trim().max(max);
exports.EstateRubyAddressSchema = zod_1.z.object({
    line1: s(200).min(1), line2: s(200).default(''),
    city: s(100).min(1), state: s(50).min(2), zip: s(20).min(5),
});
const Kind = zod_1.z.enum(['residential', 'commercial', 'mixed']);
exports.EstateLookupRequestSchema = zod_1.z.object({ address: exports.EstateRubyAddressSchema, kind: Kind });
exports.EstateValuationRequestSchema = zod_1.z.object({
    propertyId: s(80).min(1), address: exports.EstateRubyAddressSchema, kind: Kind,
    subtype: estate_1.EstatePropertySubtypeSchema.optional(),
    beds: zod_1.z.number().min(0).max(50).optional(), baths: zod_1.z.number().min(0).max(50).optional(),
    sqft: zod_1.z.number().int().min(0).max(10000000).optional(),
});
exports.EstateRentRequestSchema = zod_1.z.object({
    propertyId: s(80).min(1), address: exports.EstateRubyAddressSchema, kind: Kind,
    subtype: estate_1.EstatePropertySubtypeSchema.optional(),
    units: zod_1.z.array(zod_1.z.object({
        unitId: s(80).min(1),
        beds: zod_1.z.number().min(0).max(50).optional(), baths: zod_1.z.number().min(0).max(50).optional(),
        sqft: zod_1.z.number().int().min(0).max(1000000).optional(),
    })).min(1).max(8),
});
/** `snapshot` = JSON text of what the Overview shows (built client-side), ≤ 8 KB. */
exports.EstateAnalysisRequestSchema = zod_1.z.object({ propertyId: s(80).min(1), snapshot: zod_1.z.string().max(8000) });
//# sourceMappingURL=estateRuby.js.map